import { getMockAdapter } from './mock';
import {
  questionsHistoryMatching,
  questionsHistoryOngoing,
  pickQuestionHadPicked,
} from './response/tutor';

export default function mockTutor() {
  const mock = getMockAdapter();
  mock
    .onGet(
      /https:\/\/alb-uat.snapask.co\/api\/v2\/tutors\/[\d]+\/questions_history/
      /* 
        TODO: use the second parameter to differentiate the two API calls
        currently use config of return function to differentiate the two types of mock data 
        because based on my multiple attempts, the second parameter of .onGet does not work 
        if the value is liked ''statuses[]': 'on_going''  
      */
      // {
      //   'statuses[]': 'on_going',
      //   size_per_page: 25,
      //   page: 1,
      //   type: 'all',
      //   lang: 'zh-TW',
      // }
    )
    .reply(function (config) {
      if (config.url.indexOf('matching') !== -1) {
        return [200, questionsHistoryMatching];
      } else if (config.url.indexOf('on_going') !== -1) {
        return [200, questionsHistoryOngoing];
      }
    });

  mock
    .onPatch(
      /https:\/\/alb-uat.snapask.co\/api\/v2\/tutors\/[\d\w]+\/questions\/[\d\w]+\/pick/
    )
    .reply(500, pickQuestionHadPicked);
}



// WEBPACK FOOTER //
// ./src/mock/tutor.js